// extracted by mini-css-extract-plugin
export default {"modal":"SignupDetails_modal__7l+jd","signupDetailsMain":"SignupDetails_signupDetailsMain__Yn0L4","signupDetailsBody":"SignupDetails_signupDetailsBody__OpRj1"};